module.exports = __webpack_public_path__ + "static/media/completed.b4ba2b2d.png";